import * as React from "react"

const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="40" height="40" rx="8" fill="white" />
    <circle
      cx="25.5"
      cy="13"
      r="2.5"
      fill="#1BBD77"
      stroke="#008761"
      strokeWidth="1.5"
    />
    <circle
      cx="13.5"
      cy="20"
      r="2.5"
      fill="#1BBD77"
      stroke="#008761"
      strokeWidth="1.5"
    />
    <path
      d="M23 14.5L16 18.5"
      stroke="#008761"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 22L23 26.5"
      stroke="#008761"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="25.5"
      cy="28"
      r="2.5"
      fill="#1BBD77"
      stroke="#008761"
      strokeWidth="1.5"
    />
  </svg>
)
export default CopyIcon
